<template>
  <section id="contents" class="page_register">
  	<div id="title_block">
  		<h1 class="title_text">ご購入者様の情報</h1>
  		<p class="btn_back"><a href="javascript:history.back();">戻る</a></p>
  	</div>
    <div v-if="confirm" class="contents_inner">
  		<ul class="flow_box step_num3">
  			<li>情報入力</li>
  			<li class="current">メール確認</li>
  			<li>完了</li>
  		</ul>
  		<p class="check_text_read">まだ登録は完了しておりません。<br>
  			本人確認のために「確認コード」を送信しました。メールを確認し、6桁のコードをご入力ください。</p>
      <form @submit.prevent="mail_confirm">
  			<div class="form_box">
  				<table>
  					<tr>
  						<th>確認コード</th>
              <td><p><input type="text" placeholder="" v-model="confirmationCode" required></p></td>
  					</tr>
  				</table>
  			</div>
  			<p class="submit"><input type="submit" value="完了へ"></p>
  		</form>
  	</div>
	  <div v-else class="contents_inner">
	  	<p class="read_text">お名前や商品のお届け先などの商品配送に必要な情報をお知らせください。<br>次回からご登録いただいた情報を用いて簡単にご購入いただけます。<br>登録されたメールアドレスとパスワードはお忘れにならないようにお控えください。</p>
	  	<ul class="flow_box step_num2">
	  		<li class="current">情報入力</li>
	  		<li>完了</li>
	  	</ul>
      <form @submit.prevent="signup">
	  		<div class="form_box">
	  			<table>
	  				<tr>
	  					<th>メールアドレス<span>必須</span></th>
	  					<td><p><input type="text" placeholder="" v-model="username" autocomplete="email" required></p></td>
	  				</tr>
	  				<tr>
	  					<th>名前<span>必須</span></th>
	  					<td class="tow"><p><input type="text" placeholder="姓" v-model="familyName" autocomplete="family-name" required><input type="text" placeholder="名" v-model="givenName" autocomplete="given-name" required></p></td>
	  				</tr>
	  				<tr>
	  					<th>電話番号<span>必須</span></th>
	  					<td><p><input type="text" placeholder="電話番号(ハイフンなし)" v-model="tel" autocomplete="tel" required></p></td>
	  				</tr>
	  				<tr>
	  					<th>法人名</th>
	  					<td><p><input type="text" placeholder="" v-model="companyName" autocomplete="organization"></p></td>
	  				</tr>
            <id-addr ref="address" :zipcode="this.zipcode" :address="this.address" @updateAddress="updateAddress"></id-addr>
	  				<tr>
	  					<th>パスワード<span>必須</span></th>
	  					<td>
                <p><input type="password" placeholder="6文字以上で設定ください" v-model="password" required></p>
                <p><input type="password" placeholder="確認用" v-model="passwordConfirm" required></p>
	  					</td>
	  				</tr>
	  			</table>
	  		</div>
	  		<div class="form_box rule_box">
	  			<h4>利用規約</h4>
          <agreement></agreement>
	  			<p class="agree_text">
	  				<input type="checkbox" id="agree" v-model="agree" />
	  				<label for="agree">同意する</label>
	  			</p>
	  		</div>
	  		<p class="submit"><input type="submit" value="この内容で登録"></p>
	  	</form>
	  </div>
  </section>
</template>

<script>
import Vue from 'vue'
import IdHeader from './Header'
import Agreement from './Agreement'
import Address from './Address'
import axios from 'axios';
Vue.component('id-header', IdHeader)
Vue.component('agreement', Agreement)
Vue.component('id-addr', Address)

export default {
  name: 'Signup',
  data () {
    return {
      confirm: false, 
      appId: this.$route.query.app_id, 
      channel: this.$route.query.channel, 
      redirect: '',
      loginUrl: '',
      username: '',
      familyName: '',
      givenName: '',
      tel: '',
      address: '',
      zipcode: '',
      agree: '',
      companyName: '',
      password: '',
      passwordConfirm: '',
      confirmationCode: ''
    }
  },
  methods: {
    signup () {
      if (this.$route.query.redirect) {
        this.redirect = decodeURIComponent(this.$route.query.redirect)
      }
      if (!this.agree) {
        window.alert('規約に同意いただく必要がございます。');
      } else if (this.username && (this.password === this.passwordConfirm)) {
        this.$refs.address.update()
        this.$cognito.signUp(this.username, this.password, this.familyName, this.givenName, this.companyName, this.tel, this.zipcode, this.address)
          .then(result => {
            this.$cognito.login(this.username, this.password).then(result => {
              this.$emit('updateLogin', true)
              this.loginUrl = process.env.SERVICES[this.appId]
              if (this.loginUrl) {
                var config = {
                  headers: { 
                    'id-token': result.idToken.jwtToken,
                    'access-token': result.accessToken.jwtToken,
                    'refresh-token': result.refreshToken.token,
                    'channel': this.channel
                  }
                }
                if (this.app_id == 'ec') config['withCredentials'] = true 
                axios.get(this.loginUrl, config)
                  .then((res) => {
                    if (res.status == 200) {
                      window.location.href = res.data.url + this.redirect
                    }
                  })
              } else {
                this.$notify({ group: 'main', duration: -1, text: '新規登録が完了しました。' })
                this.$router.replace('/login?app_id=' + this.app_id)
              }
            })
            .catch(err => {
              this.$notify({ group: 'main', type: 'error', text: 'ログインに失敗しました。再度お試しください。' })
            })
//            this.$notify({ group: 'main', duration: -1, text: 'メールを送信しました。記載の確認コードを入力してください。※メールが届かない方は迷惑メールフォルダを確認してください。' })
//            this.confirm = true
          })
          .catch(err => {
            this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.signup." + err.code) })
          })
      } else {
        this.$notify({ group: 'main', type: 'error', text: 'パスワードとパスワード（確認用）が異なります' })
      }
    },
    mail_confirm () {
      if (this.$route.query.redirect) {
        this.redirect = decodeURIComponent(this.$route.query.redirect)
      }
      this.$cognito.confirmation(this.username, this.confirmationCode)
        .then(result => {
          this.$cognito.login(this.username, this.password).then(result => {
            this.$emit('updateLogin', true)
            this.loginUrl = process.env.SERVICES[this.appId]
            if (this.loginUrl) {
              var config = {
                headers: { 
                  'id-token': result.idToken.jwtToken,
                  'access-token': result.accessToken.jwtToken,
                  'refresh-token': result.refreshToken.token,
                  'channel': this.channel
                }
              }
              if (this.app_id == 'ec') config['withCredentials'] = true 
              axios.get(this.loginUrl, config)
                .then((res) => {
                  if (res.status == 200) {
                    window.location.href = res.data.url + this.redirect
                  }
                })
            } else {
              this.$notify({ group: 'main', duration: -1, text: '新規登録が完了しました。' })
              this.$router.replace('/login?app_id=' + this.app_id)
            }
          })
          .catch(err => {
            this.$notify({ group: 'main', type: 'error', text: 'ログインに失敗しました。再度お試しください。' })
          })
        })
        .catch(err => {
          this.$notify({ group: 'main', type: 'error', text: '確認コードが正しくありません' })
        })
    },
    updateAddress (address, zipcode) {
      this.address = address
      this.zipcode = zipcode
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue